import type { ReactNode } from 'react';
import { Button, Group, Modal, Text } from '@mantine/core';

type ConfirmDeleteModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  error?: { message: string } | null;
  isLoading: boolean;
  children?: ReactNode;
};

export default function ConfirmDeleteModal({
  opened,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Delete',
  error,
  isLoading,
  children,
}: ConfirmDeleteModalProps) {
  return (
    // While the request is in flight the dialog stays open, so a failure always has somewhere to show.
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      centered
      closeOnEscape={!isLoading}
      closeOnClickOutside={!isLoading}
      withCloseButton={!isLoading}
    >
      <Text mb="md">{message}</Text>
      {children}
      {error && (
        <Text c="red" mb="md" role="alert">
          {error.message ?? 'An error occurred'}
        </Text>
      )}
      <Group justify="flex-end">
        <Button variant="subtle" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm} loading={isLoading}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
